/**
 * Ortam konfigurasyonu.
 *
 * API adresi build'e gomulmez; calisma zamaninda /config.json'dan okunur.
 * Boylece tek build artifact'i her ortamda calisir ve test/prod icin ayri
 * build gerekmez. EcupBlazor da ayni deseni kullaniyor
 * (wwwroot/appsettings.json -> AppConstants.Configure).
 */

export interface RunnerConfig {
  apiBaseUrl: string;
}

let cached: RunnerConfig | null = null;

export async function loadConfig(): Promise<RunnerConfig> {
  if (cached) return cached;

  // Local gelistirmede Vite proxy'si /api'yi API'ye yonlendirir, bu yuzden
  // bos base URL dogru davranistir.
  if (import.meta.env.DEV) {
    cached = { apiBaseUrl: "" };
    return cached;
  }

  // Zayıf bağlantıda ilk açılış "failed to fetch" vermesin: birkaç kez denenir.
  let response: Response | null = null;
  for (const bekle of [0, 1000, 2000, 4000]) {
    if (bekle) await new Promise((r) => setTimeout(r, bekle));
    try { response = await fetch("/config.json", { cache: "no-store" }); if (response.ok) break; } catch { response = null; }
  }
  if (!response) throw new Error("config.json yüklenemedi (bağlantı)");
  if (!response.ok) {
    throw new Error(`config.json yüklenemedi (${response.status})`);
  }

  const parsed = (await response.json()) as Partial<RunnerConfig>;
  if (!parsed.apiBaseUrl) {
    throw new Error("config.json içinde apiBaseUrl yok");
  }

  cached = { apiBaseUrl: parsed.apiBaseUrl.replace(/\/+$/, "") };
  return cached;
}
